import { useState } from 'react'

export interface FAQItemProps {
  question: string
  answer: { __html: string | TrustedHTML; }
}

export const useFAQItem = (props: FAQItemProps) => {
  const [isActive, setIsActive] = useState(false)

  const handleClick = () => {
    setIsActive(!isActive)
  }
  return {
    ...props,
    isActive,
    handleClick,
  }
}
